<template>
  <div class="col-sm-12 mt-4 text-center">
    <div class="col-lg-4 offset-lg-4">
      <button type="button" name="button" class="btn action_box w-100 action_box_full_width_mobile rounded-0 mb-5" @click="toogle">MAP</button>
    </div>
    <iframe style="margin:0 auto;" width="100%" height="480" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=C.A+Rosseti+nr.5&amp;aq=&amp;sll=37.0625,-95.677068&amp;sspn=39.371738,86.572266&amp;ie=UTF8&amp;hq=C.A+Rosetti+nr.5&amp;hnear=&amp;radius=15000&amp;t=m&amp;cid=5563000609928991653&amp;ll=44.444841,26.095662&amp;spn=0.014706,0.027466&amp;z=15&amp;iwloc=A&amp;output=embed" v-if="status"></iframe>
  </div>
</template>

<script>
export default {
  name: "google",
  data: function() {
    return {
      status: false,
    }
  },
  methods: {
    toogle: function() {
      if (this.status == false) {
        this.status = true
      } else {
        this.status = false
      }
    }
  },

}
</script>
